import { useQuery } from "@tanstack/react-query";
import { notification } from "antd";
import { projectQueries } from "@/entities/project";
import { Can } from "@/shared/lib/casl";
import { useCoordinator } from "@/shared/lib/hooks";
import { SettingsCardBlock } from "@features/settings-card-block";
import "./project-settings.scss";

export const ProjectSettings = () => {
  const { projectId } = useCoordinator() as { projectId: string };
  const { data, isLoading, isError, error } = useQuery(
    projectQueries.getProjectSettings({ projectId }),
  );

  if (isError && error) {
    notification.error({
      message: "Не можем отобразить настройки проекта",
      description: ``,
      placement: "topRight",
      showProgress: false,
    });
  }

  return (
    <>
          <Can I="edit" a="project">
            <SettingsCardBlock
              blockTitle="Интеграции"
              settingsList={data?.settings}
              isLoading={isLoading}
            />
          </Can>

      {/* <ProjectSettingsIndividual /> */}
    </>
  );
};
